__turbopack_context__.v({
  "backRow": "mobile-menu-module__ox1JSq__backRow",
  "burger": "mobile-menu-module__ox1JSq__burger",
  "burgerOpen": "mobile-menu-module__ox1JSq__burgerOpen",
  "drawer": "mobile-menu-module__ox1JSq__drawer",
  "itemChevron": "mobile-menu-module__ox1JSq__itemChevron",
  "itemDesc": "mobile-menu-module__ox1JSq__itemDesc",
  "itemIcon": "mobile-menu-module__ox1JSq__itemIcon",
  "itemText": "mobile-menu-module__ox1JSq__itemText",
  "itemTitle": "mobile-menu-module__ox1JSq__itemTitle",
  "list": "mobile-menu-module__ox1JSq__list",
  "row": "mobile-menu-module__ox1JSq__row",
  "rowItem": "mobile-menu-module__ox1JSq__rowItem",
  "rowLink": "mobile-menu-module__ox1JSq__rowLink",
  "tag": "mobile-menu-module__ox1JSq__tag",
  "title": "mobile-menu-module__ox1JSq__title",
});
